import { Component, HostListener, Inject, inject, OnInit, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { ScrollSpyDirective } from 'src/app/scroll-spy.directive';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { filter } from 'rxjs';

@Component({
  selector: 'app-header',
  imports: [CommonModule, RouterModule, ScrollSpyDirective, TranslateModule ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit {
  activeSection: string | null = null;
  currentLang: string;
  isMobileMenuOpen = false;
  theme = 'dark';
  router = inject(Router);


  @HostListener('window:scroll', [])
onWindowScroll() {
  const contactSection = document.getElementById('contact');
  const contactBtn = document.querySelector('.contact-button');
  if (!contactSection || !contactBtn) return;

  const rect = contactSection.getBoundingClientRect();
  const inView = rect.top < window.innerHeight && rect.bottom > 0;

  if (inView) {
    contactBtn.classList.add('pulse-header');
  } else {
    contactBtn.classList.remove('pulse-header');
  }
}

  constructor(  private translate: TranslateService,
    @Inject(PLATFORM_ID) private platformId: any) {
      if (isPlatformBrowser(this.platformId)) {
        const savedLang = localStorage.getItem('preferredLang');
        this.currentLang = savedLang || this.translate.getDefaultLang();
      } else {
        this.currentLang = this.translate.getDefaultLang();
      }
  }
  toggleMobileMenu() {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  scrollToTop(event: Event): void {
    event.preventDefault();
    this.closeMenu();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  
  closeMenu() {
    this.isMobileMenuOpen = false;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: UIEvent) {
    const target = event.target as Window;
    if (target.innerWidth > 768 && this.isMobileMenuOpen) {
      this.closeMenu();
    }
  }


  toggleTheme() {
    if (isPlatformBrowser(this.platformId)) {
      const body = document.body;
      this.theme = this.theme === 'dark' ? 'light' : 'dark';
      body.classList.toggle('dark-mode', this.theme === 'dark');
      localStorage.setItem('theme', this.theme);
    }
  }
  
  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      const saved = localStorage.getItem('theme') || 'dark';
      this.theme = saved;
      document.body.classList.toggle('dark-mode', saved === 'dark');
    }
  
    this.setActiveSection(this.router.url);
  
    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe((event) => {
        this.setActiveSection(event.urlAfterRedirects);
      });
  }
  
  
  get isDarkMode(): boolean {
    return this.theme === 'dark';
  }

  private setActiveSection(url: string) {
    if (url.startsWith('/blog')) {
      this.activeSection = 'blog';
    } else if (url.startsWith('/signalbot')) {
      this.activeSection = 'signalbot';
    } else {
      this.activeSection = null;
    }
  }

  setLanguage(lang: 'de' | 'en') {
    this.translate.use(lang);
    this.currentLang = lang;
  
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('preferredLang', lang);
    }
  }
  
}



